'use strict';

module.exports = {
    ENDPOINT: 'ENDPOINT',
    JET_DELIVERY: 'JET_DELIVERY',
    JET_JOB: 'JET_JOB',
    JET_TRANSFER: 'JET_TRANSFER',
    STORAGE_PROFILE: 'STORAGE_PROFILE'
};